import Vue from "vue";
import PortalVue from "portal-vue";
import camelCase from "@/plugins/lodash/camelCase.js";
import upperFirst from "@/plugins/lodash/upperFirst.js";
import Popover from "@/core/shared/Popover";
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
// import vue_fb from '@/plugins/fb-sdk.js';

const requireComponent = require.context(
  // The relative path of the components folder
  "@/core/shared/base",
  // Whether or not to look in open subfolders
  false,
  // /Base[A-Z]\w+\.(vue|js)$/
  /[\w-]+\.vue$/
);

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);

  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
      .split("/")
      .pop()
      .replace(/\.\w+$/, "")
    )
  );

  // Register component globally
  Vue.component(componentName, componentConfig.default || componentConfig);
});

Vue.use(PortalVue);
Vue.use(Popover, { tooltip: true });
Vue.use(PerfectScrollbar)
// Vue.use(vue_fb, {
//   appId: '1111111111',
//   xfbml: true,
//   version: 'v2.7'
// })
